module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre1"
    }
  }, [_vm._v("Foreword by Todd Hunter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("Part One: The Shape of Constraint")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("1")]), _vm._v(" River, the Womb, and Hearth"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("A Meditation on the Constraints of the Church")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("2")]), _vm._v(" Freedom"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("A Meditation on the Journey to Our Healing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("3")]), _vm._v(" Constraint:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("A Meditation on the Education of Love and Humility")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("4")]), _vm._v(" Practicing Constraint:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Choosing and Consenting")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Constraints We Choose")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("5")]), _vm._v(" Silence and Solitude:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Choosing the Constraint of the Present Moment")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("6")]), _vm._v(" Simplicity:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Choosing the Constraint of Our Attention")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("7")]), _vm._v(" Marriage and Celibacy:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Choosing the Constraint of Love")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Constraints We Consent To")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("8")]), _vm._v(" Formational Healing:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Consenting to the Constraint of One's Own Story")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("9")]), _vm._v(" Faults and Affirmations:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Consenting to the Constraint of What Is True")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("10")]), _vm._v(" Discernment in Community:"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Consenting to the Constraints of One Another")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Word: Weeds and Wheat")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gratitudes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Finding Freedom in Constraint")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0